define.alias("shared/components/shared/address-fields/item", "settings/components/shared/address-fields/item");